<template>
<!-- 主页 -->
  <div class="home">
<!-- 走马灯 -->
<el-row>
  <el-col :span="24"><div class="Riding_Lantern">
<el-carousel :interval="5000" arrow="always" v-if="WidthSize>768" height="9rem">
  <!--  12rem 6rem -->
    <el-carousel-item v-for="home3 in home3" :key="home3.poster_id">
      <img :src="home3.posteraddress" alt="">
    </el-carousel-item>
  </el-carousel>
  <!-- iphone -->
  <el-carousel :interval="5000" arrow="always" v-else height="6rem">
    <!--  12rem 6rem -->
      <el-carousel-item v-for="home3 in home3" :key="home3.poster_id">
        <img :src="home3.posteraddress" alt="">
      </el-carousel-item>
    </el-carousel>
  </div></el-col>
</el-row>
<!-- 课程 -->
<el-row>
  <el-col :span="24" :offset="0"><div class="curriculum_Title">网校课程</div></el-col>
</el-row>
<el-row>
  <el-col :span="24" :offset="0"><div class="curriculum_Title2">精选网校课程，满足你的学习兴趣。</div></el-col>
</el-row>
<!-- 内容 -->
<el-row>
  <el-col :span="20" :offset="2">

<div class="section">
	<!-- 标题 -->
	<el-row>
	<el-col :span="24"><div class="title">
	<el-row>
	<el-col :span="8"><div class="title_left"><h5 @click="getAll,cur=0">推荐</h5></div></el-col>
	<el-col :span="12" :offset="4" :class="{none:WidthSize<768}"><div class="title_right">
	<ul ref="titleUl">
		<li  @click="cur=1,getproductList(cur)" :class="{active:cur==1}"><span>最新</span></li>
		<li @click="cur=2,getproductList(cur)" :class="{active:cur==2}">最热</li>
		<li @click="cur=3,getproductList(cur)" :class="{active:cur==3}">全部</li>
	</ul>
	</div></el-col>
	</el-row>
	</div></el-col>
	</el-row>
	<!-- 内容 -->
	<el-row v-show="cur==0">
	<el-col :span="24"><div class="content">
	<ul>
	<li v-for="getAlls in getAlls" :key="getAlls.id" ref="ibb" :class="{widthMax:WidthSize<767}">
    <router-link :to="'/details/' + getAlls.id">
	<div class="font" > <!-- @click="detailsing(getAlls)" -->
		<img :src="getAlls.book_image_address" alt="" :class="{imgMax:WidthSize<767}">
		<p></p>
		<p></p>
		<p>免费</p>
	</div>
  </router-link>
	</li>
	</ul>
	</div></el-col>
	</el-row>
<!-- 1 -->
	<el-row v-show="cur==1">
	<el-col :span="24"><div class="content">
	<ul>
	<li v-for="getList in getList" :key="getList.index">
     <router-link :to="'/details/' + getAlls.id" >
	<div class="font">
		<img :src="getList.book_image_address" alt="">
		<p></p>
		<p></p>
		<p>免费</p>
	</div>
  </router-link>
	</li>
	</ul>
	</div></el-col>
	</el-row>
<!-- 2 -->
	<el-row v-show="cur==2">
	<el-col :span="24"><div class="content">
	<ul>

<li v-for="getList in getList" :key="getList.index">
     <router-link :to="'/details/' + getAlls.id">
	<div class="font">
		<img :src="getList.book_image_address" alt="">
		<p></p>
		<p></p>
		<p>免费</p>
	</div>
  </router-link>
	</li>

	</ul>
	</div></el-col>
	</el-row>
  <!-- 3 -->
<el-row v-show="cur==3">
	<el-col :span="24"><div class="content">
	<ul>

<li v-for="getList in getList" :key="getList.index">
     <router-link :to="'/details/' + getAlls.id">
	<div class="font">
		<img :src="getList.book_image_address" alt="">
		<p></p>
		<p></p>
		<p>免费</p>
	</div>
  </router-link>
	</li>

	</ul>
	</div></el-col>
	</el-row>
  <!-- 3 -->
<!-- 更多课程 -->
<el-row>
  <el-col :span="24"><div class="More"><h5>更多课程</h5></div></el-col>
</el-row>
</div>

  </el-col>
</el-row>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  data() {
return {
cur:0,
WidthSize:1001,
token:'',
touxiang:false
}
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResizeing();
    // console.log(localStorage.getItem("bar"))
  },
watch:{
wode () {
  // console.log(this.getList);
}
},
  methods: {
    // 点击发送请求
	getproductList(cur) {
		this.$store.dispatch('getproductList',cur);
	},
  // 推荐
  getAll() {
	this.cur==0,
	this.$store.dispatch('getAll')
  },
  // 适配
  handleResizeing() {
      this.WidthSize = window.outerWidth
  },
  handleResize(e) {
    // console.log(e.currentTarget.innerWidth)
    this.WidthSize = e.currentTarget.innerWidth
  },
  // 进入详情
  // detailsing (e) {
  //   console.log(e)
  // }
  },
  // 路由，判断是否为登录状态
  beforeRouteEnter(to, from , next) {
    // console.log(to)
    to,
    from,
    // if(localStorage.getItem('user')) {
    // }else {
    //   }
      // 放行
      next()

  },
  components: {
  },
  computed: {
    // 获取首页的数据
    // console.log(localStorage.getItem('user'));
    home1 () {
      return this.$store.state.HomeModule.home1;
    },
    home2 () {
      return this.$store.state.HomeModule.home2;
    },
    home3 () {
      return this.$store.state.HomeModule.home3;
    },
    getList () {
      return this.$store.state.HomeModule.getList;
    },
    getAlls () {
      return this.$store.state.HomeModule.getAlls;
    }
  }
}
</script>

<style lang="scss">
.bottm{
	display: block !important;
}
.widthMax {
  width: 100% !important;
  margin-bottom: 0.2rem;
}
.imgMax {
  height: 4rem !important;
}
.home {
	width: 100%;
    background-color: #f5f8fa;
	// 走马灯
	.Riding_Lantern {
		// height: 12.5rem;
		// background-color: yellow;
    img {
      width: 100%;
      height: 100%;
      border: none;
    }
	}
	// 课程标题
	.curriculum_Title {
		height: 2rem;
		// background-color: red;
		font-size: 0.75rem;
		line-height: 2rem;
		// padding: 1.25rem;
		margin-top: 0.5rem;
	}
	.curriculum_Title2 {
    width: 100%;
		height: 2rem;
		font-size: 0.6rem;
		color: #999;
		// line-height: 2rem;
		margin-top: 0.2rem;
	}
	// 课程内容
	.section{
		// height: 10rem;
    width: 100%;
		// background-color: red;
		margin-top: 0.1rem;
    // margin-bottom: 0.5rem;
		.title {
			height: 1.5rem;
      // background-color: red;
			.title_left {
				h5 {
					float: left;
					width: 2rem;
					margin-top: 0.3rem;
					height: 1rem;
					font-size: 0.5rem;
					font-weight: 400;
					line-height: 1rem;
					color: #FFFFFF;
					border-radius: 0.2rem;
					background-color: #46c37b;
          cursor: pointer;
				}
        h5:hover {
          background-color: #A4DA89;
        }
			}
			.title_right {
				ul {
					float: right;
					width: 5rem;
					height: 1rem;
          // background-color: yellow;
          margin-top: 0.3125rem;
          // position: relative;
					li {
						float: left;
						display: inline-block;
						width: 32%;
						height: 1rem;
						background-color: #f5f5f5;
            font-size: 0.1rem;
            line-height: 1rem;
            font-size: 0.4rem;
						cursor: pointer;
					}
					.active {
						background-color: #dcdcdc;
            color: #FFFFFF;
					}
					li:first-child {
						border-radius: 0.3125rem 0rem 0rem 0.3125rem;
					}
					li:nth-child(2) {
						border-left: 0.01rem solid #dcdcdc;
						border-right: 0.01rem solid #dcdcdc;
					}
					li:last-child {
						border-radius: 0rem 0.3125rem 0.3125rem 0rem;
					}
				}
			}
			.title_left,.title_right {
				height: 1rem;
				// background-color: #999;
				line-height: 3.125rem;
			}
		}
		// 内容
		.content {
			margin-top: 0.2rem;
			// height: 43.75rem;
			// background-color: red;
			ul {
				width: 100%;
				// height: 100%;
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				li {
					display: inline-block;
					width: 30%;
          margin-top: 0.2rem;
					height: 5rem;
					border: 0.01rem solid #e4ecf3;
					transition: all 0.5s;
					z-index: 999;
					border-radius: 0.3125rem;
          background-color: #FFFFFF;
					// cursor: ;
					.font {
						width: 100%;
						height: 100%;
						position: relative;
						img {
							position: absolute;
							left: 0.625rem;
							top: 0.225rem;
							width: 80%;
							height: 80%;
							background-color: #999;
						}
						p {
							position: absolute;
							font-size: 0.4rem;
						}
						p:first-of-type {
							left: 0rem;
							top: 0.6rem;
							color: #46c37b;
						}
						p:nth-of-type(2) {
							left: 0.625rem;
							top: 2rem;
						}
						p:last-of-type {
							bottom: 0.2rem;
							left: 0.625rem;
							color: #46c37b;
						}
					}
				}
				li:hover {
					margin-top: -10px;
					box-shadow: 0rem 0.625rem 1.25rem #dcdcdc;
				}
			}
		}
		// 更多课程
		.More {
			margin-top: 2rem;
			height: 3rem;
			h5 {
				font-size: 0.6rem;
				font-weight: 400;
				cursor: pointer;
				display: block;
        a {
          color: #000;
        }
        // a:hover {
        // 	color: #46c37b;
        // }
			}
		}
	}
}
</style>
